import { CellContext } from '@tanstack/react-table';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

interface NestedInstallmentDetailsValue {
  installmentId: string | null;
  currency: string;
  orderNumber: number | null;
}

export const nestedInstallmentDetailsFieldRender = <T,>(
  info: CellContext<T, unknown>,
) => {
  const value = info.getValue() as
    | NestedInstallmentDetailsValue
    | null
    | undefined;
  if (!value || value.installmentId === null) return <EmptyValue />;
  return `Rata ${value.orderNumber} (${value.currency})`;
};
